import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'li' };

class BreadcrumbItem extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-breadcrumb__item',
            className,
        ];
    }

}

BreadcrumbItem.propTypes = propTypes;

BreadcrumbItem.defaultProps = defaultProps;

export default BreadcrumbItem;
